import { Container } from 'react-bootstrap';
import '../index.scss';

const Contacts = () => {
  return (
    <div className="prmPage" data-testid="prm-contacts-page">
      <Container>
        <h1 className="Heading Heading--h5">Contacts</h1>
        <p className="Preamble">Contacts will be available here soon.</p>
      </Container>
    </div>
  );
};

export default Contacts;
